import { graphql, useStaticQuery } from 'gatsby'

export const useContactUsSection = () => {
  const { wp } = useStaticQuery<Queries.useContactUsSectionQueryQuery>(graphql`
    query useContactUsSectionQuery {
      wp {
        acfOptionsSekceKontaktujteNas {
          contactUsSection {
            personName
            position
            photo {
              gatsbyImage(height: 400, layout: CONSTRAINED)
            }
            phone
          }
        }
      }
    }
  `)

  return {
    contactUsSection: wp?.acfOptionsSekceKontaktujteNas!.contactUsSection!,
  }
}
